<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <div style="position: absolute; right: 3px; top: 3px">
        <v-btn flat icon color="grey" @click="edit = true" v-if="userAuthClass">
          <v-icon>edit</v-icon>
        </v-btn>
      </div>

      <!-- <div class="">
                <v-avatar :color="color" size="66" class="overlap-avatar">
                    <span class="white--text headline">{{letter.toUpperCase()}}</span>
                </v-avatar>
      </div>-->
      <div class="pa-3" style="justify-content: center;">
        <div
          :class="color +' rounded vertical-center-container white--text title font-weight-regular overlap-avatar mx-auto'"
          style="height:65px; width:150px; justify-content: center;"
        >{{vehicleType.name}}</div>
      </div>

      <v-card-text>
        <div class="pb-3">
          <h5
            class="subheading font-weight-regular text-capitalize"
          >{{vehicleType.name}} ({{titleCase(vehicleType.class)}})</h5>
          <!-- <div class="grey--text text-capitalize"><span class="clickable">{{vehicleType.contractor.name}}</span></div> -->
        </div>
        <div class="pb-4">
          <h5
            class="subheading font-weight-regular grey--text text--darken-1"
          >{{vehicleType.details}}</h5>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :subject="vehicleType" :time="vehicleType.updatedAt" needsParse updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>

      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT DRIVER DIALOG -->
    <v-dialog v-model="edit" max-width="700px" @keydown.esc="edit = false" v-if="userAuthClass">
      <edit-vehicleType
        :vehicleType="vehicleType"
        @close="edit = false"
        @vehicleTypeEdited="displaySnack"
      ></edit-vehicleType>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog
      v-model="deleteDialog"
      max-width="400px"
      @keydown.esc="deleteDialog = false"
      v-if="userAuthClass"
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{vehicleType.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteVehicleType(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import VehicleService from "@/services/requests/vehicleService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditVehicleType from "@/components/vehicleTypes/editVehicleType";
import DisplaySnack from "@/services/mixins/displaySnack";

export default {
  components: {
    EditVehicleType
  },
  mixins: [DisplaySnack],
  data() {
    return {
      edit: false,
      deleteDialog: false
    };
  },
  methods: {
    titleCase(str) {
      return str.toLowerCase();
      return str.replace(/\w\S/g, function(t) {
        return t.toUpperCase();
      });
    },
    deleteVehicleType() {
      var vehicleType = this.vehicleType;
      VehicleService.deleteVehicleType(vehicleType.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("vehicleTypes/deleteFromArrayStateByValue", {
            prop: "vehicleTypes",
            value: vehicleType
          });
          this.snack({ text: "VehicleType was deleted!", color: "yellow" });
        })
        .catch(err => {
          //console.log("An error occured");
          this.snackError();
        });
    }
  },
  props: {
    vehicleType: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.vehicleType.name.charCodeAt(0));
    },
    letter() {
      return this.vehicleType.name.charAt(0);
    }
  },
  components: {
    EditVehicleType
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -48px;
  border: 6px solid #eee;
  border-color: #eee !important;
}

.rounded {
  border-radius: 10px;
}
</style>
